/**
 * Created by fjywan on 2018/3/16.
 */
import Normal from '../views/lists/normal.js'
import Nested from '../views/lists/nested.js'
import Parallel from '../views/lists/parallel.js'

export default {
  routes: [
    {
      path: '/role/:view?/:from?',
      component: Normal,
      meta: {
        title: 'Normal View'
      }
    },
    {
      path: '/user/:view?/:from?',
      component: Nested,
      meta: {
        title: 'Nested View'
      }
    },
    {
      path: '/item/:view?/:from?',
      component: Parallel,
      meta: {
        title: 'Parallel View'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./examples/router/lists.js